import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Stack,
  Chip,
  Switch,
} from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";

/* ================= ROLE DATA ================= */

const initialRows = [
  {
    id: 1,
    role: "Admin",
    risk: "High",
    description: "Full access to all modules and features",
    modules: ["All Modules"],
    autonomy: "Full Access",
    autonomyEnabled: true,
    apiAccess: true,
  },
  {
    id: 2,
    role: "Data Analyst",
    risk: "Medium",
    description: "View analytics and trend reports",
    modules: ["Analytics"],
    autonomy: "Full Access",
    autonomyEnabled: true,
    apiAccess: false,
  },
  {
    id: 3,
    role: "Risk Auditor",
    risk: "High",
    description: "Audit permissions for Core + Pricing modules",
    modules: ["Bouteek Core", "Pricing Engine"],
    autonomy: "Level 1 Recommend Only",
    autonomyEnabled: true,
    apiAccess: true,
  },
  {
    id: 4,
    role: "Vendor Representative",
    risk: "Low",
    description: "Manage vendor profiles (Finance, Catalog)",
    modules: ["Product Management", "Analytics"],
    autonomy: "Level 1 Recommend Only",
    autonomyEnabled: false,
    apiAccess: false,
  },
];

const PermissionTables = () => {
  const [rows, setRows] = useState(initialRows);

  const handleAutonomyToggle = (id: number) => {
    setRows((prev) =>
      prev.map((row) =>
        row.id === id
          ? { ...row, autonomyEnabled: !row.autonomyEnabled }
          : row
      )
    );
  };

  const handleApiToggle = (id: number) => {
    setRows((prev) =>
      prev.map((row) =>
        row.id === id
          ? { ...row, apiAccess: !row.apiAccess }
          : row
      )
    );
  };

  return (
    <div className="lt permission_table">

      {/* ================= TABLE 1 ================= */}
      <TableContainer className="table_container">
        <Table className="lt_table_inner">
          <TableHead className="lt_thead">
            <TableRow>
              <TableCell className="lt_th">Sr. No.</TableCell>
              <TableCell className="lt_th">Role</TableCell>
              <TableCell className="lt_th">Risk Level</TableCell>
              <TableCell className="lt_th">Description</TableCell>
              <TableCell className="lt_th">Modules & Categories</TableCell>
              <TableCell className="lt_th">AI Autonomy Level</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {rows.map((row, index) => (
              <TableRow key={row.id} className="lt_tr" hover>
                <TableCell className="lt_td">{index + 1}</TableCell>
                <TableCell className="lt_td lt_tier">
                  {row.role}
                </TableCell>

                {/* RISK PILL */}
                <TableCell className="lt_td">
                  <span className={`risk_pill ${row.risk.toLowerCase()}`}>
                    {row.risk}
                  </span>
                </TableCell>

                <TableCell className="lt_td">
                  {row.description}
                </TableCell>

                {/* MODULES */}
                <TableCell className="lt_td">
                  <Stack direction="column" spacing={1}>
                    {row.modules.map((mod) => (
                      <span key={mod} className="module_chip">
                        {mod}
                      </span>
                    ))}
                  </Stack>
                </TableCell>

                {/* AUTONOMY CELL */}
                <TableCell className="lt_td">
                  <div className="autonomy_box">
                    <div className="autonomy_text">
                      {row.autonomy}
                    </div>

                    {!row.autonomyEnabled && (
                      <LockOutlinedIcon fontSize="small" />
                    )}

                    <Switch
                      size="small"
                      checked={row.autonomyEnabled}
                      onChange={() =>
                        handleAutonomyToggle(row.id)
                      }
                    />
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* ================= TABLE 2 ================= */}
      <TableContainer className="table_container mt_30">
        <Table className="lt_table_inner">
          <TableHead className="lt_thead">
            <TableRow>
              <TableCell className="lt_th">Sr. No.</TableCell>
              <TableCell className="lt_th">Role</TableCell>
              <TableCell className="lt_th">Risk Level</TableCell>
              <TableCell className="lt_th">Description</TableCell>
              <TableCell className="lt_th">Modules & Categories</TableCell>
              <TableCell className="lt_th">API Access</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {rows.map((row, index) => (
              <TableRow key={row.id} className="lt_tr" hover>
                <TableCell className="lt_td">{index + 1}</TableCell>
                <TableCell className="lt_td lt_tier">
                  {row.role}
                </TableCell>

                <TableCell className="lt_td">
                  <span className={`risk_pill ${row.risk.toLowerCase()}`}>
                    {row.risk}
                  </span>
                </TableCell>

                <TableCell className="lt_td">
                  {row.description}
                </TableCell>

                <TableCell className="lt_td">
                  <Stack direction="column" spacing={1}>
                    {row.modules.map((mod) => (
                      <span key={mod} className="module_chip">
                        {mod}
                      </span>
                    ))}
                  </Stack>
                </TableCell>

                {/* API SWITCH */}
                <TableCell className="lt_td">
                  <div className="api_toggle">
                    <span>{row.apiAccess ? "On" : "OFF"}</span>
                    <Switch
                      size="small"
                      checked={row.apiAccess}
                      onChange={() =>
                        handleApiToggle(row.id)
                      }
                    />
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default PermissionTables;
